import { MessageType } from "winslow-core";

export type ExpectedDisposition = "ok" | "escalate";

export type AIReplayStep = {
  inputMessage: string;
  persona: string;
  expectedMessageType: MessageType;
  expectedDisposition: ExpectedDisposition;
  expectedMessageData: any;
};

export interface AIReplayScenario {
  name: string;
  scenario: string;
  steps: AIReplayStep[];
  attempts: number;
}

// for each type you can check the following outcomes:
//
// AI_MESSAGE_UI: check the object and label
// AI_MESSAGE_REPORTING: check the rows
// AI_MESSAGE_DOCUMENT: check the match (text match of title, description, or url)
// AI_MESSAGE: check the contexts (persona names, employee names) and files (match of url or title)

export const aireplayScenarios: AIReplayScenario[] = [
  {
    name: "Smoke Test - Persona Changes",
    scenario: "smoke-persona-changes",
    steps: [
      {
        inputMessage: "Do we have monday off",
        persona: "Dalton Wais",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "company-holidays",
          label: "view",
        },
      },
      {
        inputMessage: "Do we have monday off again",
        persona: "Dalton Wais",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "company-holidays",
          label: "view",
        },
      },
      {
        inputMessage: "Do we have tuesday off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "company-holidays",
          label: "view",
        },
      },
      {
        inputMessage: "Do we have tuesday off again",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "company-holidays",
          label: "view",
        },
      },
      {
        inputMessage: "Do we have wednesday off",
        persona: "Niel Robertson",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "company-holidays",
          label: "view",
        },
      },
      {
        inputMessage: "Do we have wednesday off again",
        persona: "Niel Robertson",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "company-holidays",
          label: "view",
        },
      },
    ],
    attempts: 1,
  },
  {
    name: "Smoke Test - Demo",
    scenario: "smoke-demo",
    steps: [
      {
        inputMessage: "I want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "pto-request",
          label: "ptoRequest",
        },
      },
      {
        inputMessage: "Approve PTO for Dalton",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "pto-history",
          label: "ptoHistory",
        },
      },
      {
        inputMessage:
          "run a report of all employees who live in colorado and started after Jan 1, 2024",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_REPORTING,
        expectedDisposition: "ok",
        expectedMessageData: {
          rows: 1,
        },
      },
    ],
    attempts: 3,
  },
  {
    name: "Smoke Test - Each Type",
    scenario: "smoke-types",
    steps: [
      {
        inputMessage: "run a report of all employees who live in colorado",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_REPORTING,
        expectedDisposition: "ok",
        expectedMessageData: {
          rows: 1,
        },
      },
      {
        inputMessage: "i want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "pto-request",
          label: "ptoRequest",
        },
      },
      {
        inputMessage: "what is our policy on paternity leave?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
      {
        inputMessage: "find me the contractor agreement template",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_DOCUMENT,
        expectedDisposition: "ok",
        expectedMessageData: {
          match: "contractor agreement template",
        },
      },
    ],
    attempts: 1,
  },
  {
    name: "Smoke Test - Escalation",
    scenario: "smoke-escalation",
    steps: [
      {
        inputMessage: "i was harassed by my boss, what do i do?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "escalate",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "Smoke Test - Expect Failures",
    scenario: "smoke-expect-failure",
    steps: [
      {
        inputMessage: "i want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "pto-request",
          label: "XXX",
        },
      },
      {
        inputMessage: "i want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "XXX",
          label: "ptoRequest",
        },
      },
      {
        inputMessage: "i want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
      {
        inputMessage: "i want to take time off",
        persona: "XXX",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "pto-request",
          label: "ptoRequest",
        },
      },
      {
        inputMessage: "i want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "escalate",
        expectedMessageData: {
          object: "pto-request",
          label: "ptoRequest",
        },
      },
    ],
    attempts: 1,
  },
  {
    name: "Smoke Test - Multiple Attempts",
    scenario: "smoke-multiple-attempts",
    steps: [
      {
        inputMessage: "i want to take time off",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE_UI,
        expectedDisposition: "ok",
        expectedMessageData: {
          object: "pto-request",
          label: "ptoRequest",
        },
      },
    ],
    attempts: 3,
  },
  {
    name: "Smoke Test - Personas",
    scenario: "smoke-personas",
    steps: [
      {
        inputMessage: "what are my healthcare deductible costs",
        persona: "Dalton Wais",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
      {
        inputMessage: "what are my healthcare deductible costs",
        persona: "Niel Robertson",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
      {
        inputMessage: "what are my healthcare deductible costs",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
      {
        inputMessage: "what are my healthcare deductible costs",
        persona: "XXX",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "Smoke Test - Bad Persona Employee",
    scenario: "smoke-bad-persona-employee",
    steps: [
      {
        inputMessage: "what are my healthcare deductible costs",
        persona: "XXX",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_basic-10: Retrieval Accuracy - Multiple Questions",
    scenario: "ws_basic-10",
    steps: [
      {
        inputMessage:
          "What is the 401k match percentage? How many vacation days do I accrue in my first year? What is the frequency of performance evaluations?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_basic-16: Semantics - Very Short Questions",
    scenario: "ws_basic-16",
    steps: [
      {
        inputMessage: "PTO?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_spd_persona_plans-38: Retrieval - Needle/Haystack",
    scenario: "ws_spd_persona_plans-38",
    steps: [
      {
        inputMessage: "what are the deductibles in the anthem 1500",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_spd_persona_plans-39: Retrieval - Comparison",
    scenario: "ws_spd_persona_plans-39",
    steps: [
      {
        inputMessage:
          "Can you compare the Anthem PPO 1500/20/40/25 plan and the EPO plan in terms of deductible coinsurance and out-of-pocket maximums?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_spd_persona_plans-44: Chunking - Boundary Testing",
    scenario: "ws_spd_persona_plans-44",
    steps: [
      {
        inputMessage:
          "I'm trying to understand what I actually have to pay when I see a specialist. If I visit an in network specialist under my plan can you explain whether the deductible applies and what coinsurance or copay I am responsible for after that? I am on the Anthem PPO 1500 plan",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_spd_plans-45: Chunking - Multi-Page",
    scenario: "ws_spd_plans-45",
    steps: [
      {
        inputMessage:
          "I'm reviewing the benefits summary and it's a lot to take in. For emergency room visits can you tell me what I pay in network and whether the deductible applies or if there is a flat copay listed in the benefits table? I am on the PPO 1500 plan",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_spd_persona_plans-46: Chunking - Front - Middle - End",
    scenario: "ws_spd_persona_plans-46",
    steps: [
      {
        inputMessage:
          "I want to understand how my deductible really works over the year. When does the deductible reset what counts toward meeting it and are there services that do not apply to the deductible at all? I am on the EPO plan",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_large-47: Chunking - Front - Middle",
    scenario: "ws_large-47",
    steps: [
      {
        inputMessage:
          "I am trying to understand how much paid time off I actually get over the year. I started recently and I know vacation accrues monthly but I am also seeing references to sick leave and holidays in different places. Can you explain how vacation accrual works in my first year and what other paid time off I receive automatically without requesting PTO? ",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_basic-30: Retrieval - Fact Retrieval",
    scenario: "ws_basic-30",
    steps: [
      {
        inputMessage:
          "As a remote employee working from the UK, can I exchange a US holiday for a UK public holiday, and will I receive holiday premium pay if required to work?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_basic-57: Conditional Logic - Nested Decision Tree",
    scenario: "ws_basic-57",
    steps: [
      {
        inputMessage:
          "If I'm a full-time employee working 40 hours per week who gets married and wants to add my spouse to health insurance while also requesting flexible work arrangements and professional development funding what are the different approval processes and eligibility criteria I need to navigate?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_calculation_sum-60: Retrieval - Precision",
    scenario: "ws_calculation_sum-60",
    steps: [
      {
        inputMessage:
          "I started employment on March 15th and want to know exactly how many vacation days I will have accrued by December 31st of my first year and what my available balance will be on January 1st of my second year?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_basic-9: Retrieval - MultiQuestion",
    scenario: "ws_basic-9",
    steps: [
      {
        inputMessage:
          "What is the 401k match percentage? When can I enroll in the retirement plan? How do I manage my contributions?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_large-48: Retrieval - Policy Combination",
    scenario: "ws_large-48",
    steps: [
      {
        inputMessage:
          "I am planning time off around the end of the year and want to know exactly which holidays the company observes and what happens if a holiday falls on a weekend. I am also non exempt so I need to understand how holiday pay works if I am required to work.",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_large-49: Retrieval - Front/End",
    scenario: "ws_large-49",
    steps: [
      {
        inputMessage:
          "If I have a performance review that I disagree with and I think it affects my chances for promotion what options do I have to challenge it and how does that tie into future career advancement decisions?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
  {
    name: "ws_basic_noise-20: Retrieval - Multiple Questions + Noise",
    scenario: "ws_basic_noise-20",
    steps: [
      {
        inputMessage:
          "What is the 401k match percentage? How many vacation days do I accrue in my first year? What is the frequency of performance evaluations?",
        persona: "",
        expectedMessageType: MessageType.AI_MESSAGE,
        expectedDisposition: "ok",
        expectedMessageData: {},
      },
    ],
    attempts: 1,
  },
];
